import * as d3 from 'd3';


export type Margins = {
    top: number,
    right: number,
    bottom: number,
    left: number,
};
type GraphDimens = {
    width: number,
    height: number,
    margins: Margins,
}

export type GraphSvg = d3.Selection<SVGSVGElement, unknown, null, undefined>;
export type GraphG = d3.Selection<SVGGElement, GraphDimens, null, undefined>;


// Returns existing <svg> or creates one if missing
// Clears the content of the <svg> if it already exists
export function getGraphSvg(container: HTMLDivElement): GraphSvg {
    const rect = container.getBoundingClientRect();
    const containerWidth = rect.width;
    const containerHeight = rect.height;

    let root = d3.select(container).select('svg') as GraphSvg;
    if (root.empty()) {
        root = d3.select(container).append('svg')
    } else {
        root.html('');
    }
    root
        .attr('width', containerWidth)
        .attr('height', containerHeight);

    return root;
}


// Returns existing <g> or creates one if missing
export function createGraphG(root: GraphSvg, margins: Margins): GraphG {
    const width = +root.attr('width') - margins.left - margins.right;
    const height = +root.attr('height') - margins.top - margins.bottom;

    let graph = root.select('g') as GraphG;
    if (graph.empty()) {
        graph = root.append('g').attr('transform', `translate(${margins.left}, ${margins.top})`) as GraphG;
    }

    graph.datum({
        width,
        height,
        margins,
    });
    return graph;
}

export function drawNoDataMessage(root: GraphSvg) {
    root.append('text')
        .attr('x', +root.attr('width') / 2)
        .attr('y', +root.attr('height') / 2)
        .attr('text-anchor', 'middle')
        .text('No data available');
}

export function estimateFontSize(
    text: string,
    maxWidth: number,
    maxHeight?: number
): number {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    const textEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');

    textEl.textContent = text;
    textEl.setAttribute('font-size', '100');
    svg.appendChild(textEl);
    svg.setAttribute('visibility', 'hidden');
    document.body.appendChild(svg);

    const bbox = textEl.getBBox();
    const widthScale = maxWidth / bbox.width;
    const heightScale = maxHeight ? maxHeight / bbox.height : Infinity;
    const scale = Math.min(widthScale, heightScale);
    const size = Math.floor(100 * scale);

    svg.remove();
    return size;
}

export function getTextWidth(element: GraphG, text: string, fontSize: number): number {
    // Create a temporary text element
    const tempText = element.append('text')
        .style('font-size', fontSize + 'px')
        .style('visibility', 'hidden') // Hide it to avoid disrupting layout
        .text(text);

    const width = tempText.node()?.getBBox().width ?? 0;

    tempText.remove();
    return width;
}
